type Props = {
  referrer: string
}

const HttpReferrerInput = ({ referrer }: Props): JSX.Element => (
  <input name="_referrer" type="hidden" value={referrer} />
)

export default HttpReferrerInput
